import { get } from '../../utils/objectHelpers';

<if(state.isShow)>
    $ {
        const accessibilityText = get(input, 'accessibilityText', '');
        const size = get(input, 'size', 'large');
        const name = get(input, 'spinnerId', '');
        let outerClass = '';
        let innerClass = '';
        let useMask = false;

        if (size === 'large') {
            outerClass = 'str-loading-spinner';
            innerClass = 'str-loading-spinner__spinner';
            useMask = true;
        }
    }
    <div class=outerClass key="str-loading-spinner" name=name>
        <div class=innerClass>
            <ebay-progress-spinner 
                size=size
                aria-live="polite" 
                aria-label=accessibilityText />
        </div>
        <if(useMask)>
            <div class="str-loading-spinner__mask"></div>
        </if>
    </div>
</if>
